export default "__VITE_ASSET__a4bb0dff__"